import { render, staticRenderFns } from "./OfferTabDetails.vue?vue&type=template&id=576820a9&scoped=true"
import script from "./OfferTabDetails.vue?vue&type=script&lang=js"
export * from "./OfferTabDetails.vue?vue&type=script&lang=js"
import style0 from "./OfferTabDetails.vue?vue&type=style&index=0&id=576820a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576820a9",
  null
  
)

export default component.exports